import React, { Component } from 'react'
import {
    Container, Row, Col
} from 'reactstrap'

import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { u1F69C } from 'react-icons-kit/noto_emoji_regular/u1F69C' //tractor
import { u1F697 } from 'react-icons-kit/noto_emoji_regular/u1F697' // auto
import { u2764 } from 'react-icons-kit/noto_emoji_regular/u2764' // corazon
import { u1F6C4 } from 'react-icons-kit/noto_emoji_regular/u1F6C4' // maleta
//import { u1F4CA } from 'react-icons-kit/noto_emoji_regular/u1F4CA' // graficas
import { u1F3E0 } from 'react-icons-kit/noto_emoji_regular/u1F3E0' // casa
import './buttonsCategory.css'

export default class ButtonsCategory extends Component {
    constructor() {
        super()
        this.state = {
            active: ''
        }
    }


    render() {
        return (
            <React.Fragment>
                <Container className="onDesktopShow fixed">
                    <Row>
                        <Link to='/productos/automotor/' title="Automotor" className="btn-danger btn-rojo expander btn">
                            <span className="expanderText"> Automotor </span>
                            <Icon size={42} icon={u1F697} />
                        </Link>
                    </Row>
                    <Row>
                        <Link to='/productos/hogar/' title="Hogar" className="btn-danger btn-rojo expander btn">
                            <span className="expanderText"> Hogar </span>
                            <Icon size={40} icon={u1F3E0} />
                        </Link>
                    </Row>
                    <Row>
                        <Link to='/productos/comercio/' title="Comercio" className="btn-danger btn-rojo expander btn">
                            <span className="expanderText"> Comercio </span>
                            <Icon size={40} icon={u1F6C4} />
                        </Link>
                    </Row>
                    <Row>
                        <Link to='/productos/rural/' title="Rural" className="btn-danger btn-rojo expander btn">
                            <span className="expanderText"> Rural </span>
                            <Icon size={40} icon={u1F69C} />
                        </Link>
                    </Row>
                    <Row>
                        <Link to='/productos/vida/' title="Vida" className="btn-danger btn-rojo expander btn">
                            <span className="expanderText"> Vida </span>
                            <Icon size={40} icon={u2764} />
                        </Link>
                    </Row>
                </Container>
                <Container className="onDesktopHide">
                    <Row>
                        <Col xs={2}>
                            <Link to='/productos/automotor/' title="Automotor" className="btn-danger btn-rojo redondo btn btn-automotor">
                                <Icon size={39} icon={u1F697} />
                            </Link>
                        </Col>
                        <Col xs={2}>
                            <Link to='/productos/inmueble/' title="Inmueble" className="btn-danger btn-rojo redondo btn btn-inmueble">
                                <Icon size={39} icon={u1F3E0} />
                            </Link>
                        </Col>
                        <Col xs={2}>
                            <Link to='/productos/comercio/' title="Comercio" className="btn-danger btn-rojo redondo btn btn-comercio">
                                <Icon size={39} icon={u1F6C4} />
                            </Link>
                        </Col>
                        <Col xs={2}>
                            <Link to='/productos/rural/' title="Rural" className="btn-danger btn-rojo redondo btn btn-rural">
                                <Icon size={39} icon={u1F69C} />
                            </Link>
                        </Col>
                        <Col xs={2}>
                            <Link to='/productos/vida/' title="Vida" className="btn-danger btn-rojo redondo btn btn-vida">
                                <Icon size={39} icon={u2764} />
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </React.Fragment>
        )
    }
}